import { IHeartbeatMonitor } from "./interfaces";

export class NoHeartbeatMonitor implements IHeartbeatMonitor {
  async createMonitor() {
    return null;
  }
  destroyMonitor() {
    return null;
  }
  beat() {
    return null;
  }
  cleanup() {}
}
